<template>
  <div>
    <v-subheader>
      <span v-if="!vehicle?.identificationnumber">
        {{ $t("components.thg.ThgMyVehicleRegistrationDetail.vehicleDataUnderReview") }}
      </span>
      <span v-else>
        {{
          $t("components.thg.ThgMyVehicleRegistrationDetail.vehicleCreated", {
            identificationnumber: vehicle.identificationnumber,
            createdReadable: vehicle?.timestamp.createdReadable
          })
        }}
      </span>
    </v-subheader>
  </div>
</template>

<script lang="ts">
import DarkModeHighlightMixin from "@/mixins/DarkModeHighlightMixin.vue";
import { IThgMyVehicle } from "@/models/thg-my-vehicle.entity";
import { ThgThgMeViewModelGen } from "@/services/thg/v1/data-contracts";
import { ThgStatusEnum } from "@/store/enum/thg/thg-status.enum";
import { Component, Prop } from "vue-property-decorator";
import ThgQuoteVehicleUpdateRegistrationDialog from "./ThgQuoteVehicleUpdateRegistrationDialog.vue";

@Component({
  components: {
    ThgQuoteVehicleUpdateRegistrationDialog
  }
})
export default class ThgMyVehicleRegistrationDetail extends DarkModeHighlightMixin {
  @Prop()
  vehicle!: IThgMyVehicle;

  @Prop()
  thgs!: ThgThgMeViewModelGen[];

  get showUpdateRegistrationDialog(): ThgThgMeViewModelGen | undefined {
    for (const thg of this.thgs) {
      if (thg.status === ThgStatusEnum.CREATED) {
        return thg;
      }
    }

    return undefined;
  }
}
</script>
